"use strict";
(function () {
    var socialShareItems = document.querySelectorAll(".socialShare");
    if (socialShareItems.length > 0) {
        socialShareItems.forEach(function (item) {
            item.setAttribute("style", "display:block");
        });
    }
})();
